/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

export const optionPortfolioType = [
  {
    id: 'limited_assurance',
    title: 'Limited Assurance Tracker',
    disabled: false
  },
  {
    id: 'aa_1000_standard',
    title: 'AA1000 Assurance Tracker',
    disabled: false
  }
  // Disabled for the pilot
  // {
  //   id: 'lower_level_commentary',
  //   title: 'Lower Level Commentary',
  //   disabled: true
  // },
];
